import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AxiosPromise } from 'axios'
import { AloActivity,cleanAloActivity, getDefaultAloActivity } from '@/models/alo/AloActivity'
import { ApiResultCode } from '@/enum/ApiResultCode'
import { getDefaultAloConfigActivity } from '@/models/alo/AloConfigActivity'

function parseActivityData(data:string) {
  const resp =  JSON.parse(data) as AlrContainer<AloActivity>  
  if(resp.resultCode == ApiResultCode.Ok){
    const acy = resp.data as AloActivity    
    if(acy?.image?.id > 1 && (!acy.images || acy.images.length == 0)) acy.images = [acy.image]
    acy.configActivity = acy.config?{...getDefaultAloConfigActivity(),...JSON.parse(acy.config)}:getDefaultAloConfigActivity()
  }    
  return resp
}

function parseActivitiesData(data:string) {  
  const resp =  JSON.parse(data) as AlrContainer<Array<AloActivity>> 
  if(resp.resultCode == ApiResultCode.Ok) {
    const acys = resp.data as Array<AloActivity>        
    acys.forEach(acy => 
      {
        if(acy?.image?.id > 1 && (!acy.images || acy.images.length == 0)) acy.images = [acy.image]
        acy.configActivity = acy.config?{...getDefaultAloConfigActivity(),...JSON.parse(acy.config)}:getDefaultAloConfigActivity()
      })   
  }    
  return resp
}

export default {
  getAllActivity(): AxiosPromise<AlrContainer<Array<AloActivity>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/Activity`, 
      method: 'GET',
      transformResponse: parseActivitiesData
    })
  },
  getActivity(idOrSlug:string|number):AxiosPromise<AlrContainer<AloActivity>> {
    return  apiHelpers.apiCall({ 
      url: `/webapi/Activity/${idOrSlug}`, 
      method: 'GET',
      transformResponse: parseActivityData
    })
  },
  saveActivity(activity:AloActivity):AxiosPromise<AlrContainer<AloActivity>> {
    cleanAloActivity(activity)
    if(activity.id) {
      return  apiHelpers.apiCall({ 
        url: `/webapi/Activity/${activity.id}`, 
        method: 'PUT',
        data: activity,
        transformResponse: parseActivityData
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `/webapi/Activity`, 
        method: 'POST',
        data: activity,
        transformResponse: parseActivityData
      })    
    }
  },
  deleteActivity(id:number):AxiosPromise<AlrContainer<AloActivity>> {
    return  apiHelpers.apiCall({ 
      url: `/webapi/Activity/${id}`, 
      method: 'DELETE',
      transformResponse: parseActivityData
    })
  },
  sortActivity(ids:string){
    return  apiHelpers.apiCall({ 
      url: `/webapi/Activity/ordre/${ids}`, 
      method: 'PUT',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AlrContainer<Array<number>>>
      }]
    })
  }
}
